import { Volume2 } from "lucide-react";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "../ui/select";
import { playVoice } from "../../lib/voice";

export const TEXTURES = ["hum", "click", "whistle", "rumble", "chirp", "bubble"];
export const PITCHES = ["low", "mid", "high"];

const Pick = ({ testId, value, options, onChange }) => (
  <Select value={value} onValueChange={onChange}>
    <SelectTrigger data-testid={testId} className="w-32 rounded-none border-slate-700 bg-slate-900 font-mono text-xs uppercase tracking-widest">
      <SelectValue />
    </SelectTrigger>
    <SelectContent className="lab-dialog">
      {options.map((o) => (
        <SelectItem key={o} value={o} data-testid={`${testId}-${o}`} className="font-mono text-xs uppercase tracking-widest">{o}</SelectItem>
      ))}
    </SelectContent>
  </Select>
);

export const VoiceControls = ({ voice = {}, onChange, soundWord, word }) => (
  <div data-testid="voice-controls" className="flex flex-wrap items-center gap-2">
    <span className="lab-label mr-1">Voice</span>
    <Pick testId="voice-texture-select" value={voice.texture || "hum"} options={TEXTURES} onChange={(texture) => onChange({ ...voice, texture })} />
    <Pick testId="voice-pitch-select" value={voice.pitch || "mid"} options={PITCHES} onChange={(pitch) => onChange({ ...voice, pitch })} />
    <button type="button" data-testid="voice-play-button" onClick={() => playVoice(voice, soundWord, word)} className="lab-btn-ghost py-1.5">
      <Volume2 size={16} /> Play
    </button>
  </div>
);
